import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComboPageBg = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 687 1008",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "#1D2A37",
			strokeOpacity: .5,
			strokeWidth: 4,
			d: "M1538.94-110.455c10.76 13.3574 13.57 31.4374 7.38 47.43L1367.51 398.92c-6.19 15.992-20.44 27.468-37.38 30.103l-489.462 76.124c-16.945 2.635-34.008-3.97-44.763-17.327L485.251 101.999c-10.755-13.3576-13.567-31.4376-7.377-47.4302L656.678-407.376c6.191-15.993 20.442-27.468 37.387-30.103l489.455-76.124c16.95-2.635 34.01 3.97 44.77 17.327l310.65 385.821Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#1D2A37",
			strokeOpacity: .5,
			strokeWidth: 10,
			d: "M1491.72-240.769c12.98 9.486 19.92 25.176 18.19 41.16l-53.15 492.483c-1.73 15.984-11.85 29.833-26.55 36.331L977.13 529.416c-14.705 6.498-31.76 4.658-44.74-4.828L532.463 232.316c-12.98-9.486-19.913-25.176-18.188-41.16l53.151-492.483c1.725-15.984 11.847-29.833 26.552-36.332l453.082-200.21c14.7-6.498 31.76-4.658 44.74 4.828l399.92 292.272Z"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_f_2179_104642)",
			children: /* @__PURE__ */ _jsx("path", {
				stroke: "#1D2A37",
				strokeOpacity: .5,
				strokeWidth: 4,
				d: "M1547.78-47.6884c9.11 14.5304 9.77 32.8158 1.74 47.968303L1317.58 437.962c-8.03 15.152-23.53 24.87-40.67 25.492l-495.019 17.97c-17.137.622-33.304-7.945-42.412-22.476L476.408 39.2368c-9.107-14.5304-9.771-32.81582-1.741-47.96837L706.612-446.413c8.03-15.153 23.534-24.87 40.671-25.493l495.017-17.97c17.14-.622 33.3 7.946 42.41 22.476l263.07 419.7116Z"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_f_2179_104642",
			width: 1102.03,
			height: 987.364,
			x: 461.079,
			y: -497.908,
			colorInterpolationFilters: "sRGB",
			filterUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					result: "effect1_foregroundBlur_2179_104642",
					stdDeviation: 3
				})
			]
		}) })
	]
});
export default SvgComboPageBg;
